module.exports = __webpack_public_path__ + "img/bkg2.0c9b13db.jpg";